import { FormField } from "@/components/ui/form-field"
import { Input } from "@/components/ui/input"

export function FormFieldPreviewRoute(): JSX.Element {
  return (
    <div className="mx-auto max-w-4xl px-8.5 py-11">
      <header className="mb-8">
        <div className="font-id text-eyebrow uppercase tracking-[0.16em] text-text-3">
          Primitive
        </div>
        <h1 className="mt-1 text-display text-text">FormField</h1>
      </header>

      <Section title="Label + hint">
        <div className="w-96">
          <FormField
            label="EPA Reg. No."
            hint="Read off the printed label, or leave blank and let the pipeline find it."
          >
            <Input mono placeholder="65331-4" />
          </FormField>
        </div>
      </Section>

      <Section title="Label + error">
        <div className="w-96">
          <FormField
            label="EPA Reg. No."
            error="Needs the company and product parts, like 65331-4."
          >
            <Input mono defaultValue="65331" />
          </FormField>
        </div>
      </Section>

      <Section title="Label + hint + error">
        <div className="w-96">
          <FormField
            label="Product name"
            hint="Match the front-panel product name exactly."
            error="Product name is required."
          >
            <Input placeholder="e.g. Roundup" />
          </FormField>
        </div>
      </Section>

      <Section title="Optional field">
        <div className="w-96">
          <FormField
            label="Notes"
            optional
            hint="Anything the reviewer downstream should know."
          >
            <Input placeholder="Optional notes" />
          </FormField>
        </div>
      </Section>

      <Section title="Disabled">
        <div className="w-96">
          <FormField label="Client" disabled hint="Set by the engagement.">
            <Input defaultValue="Acme Chemicals" />
          </FormField>
        </div>
      </Section>
    </div>
  )
}

function Section({ title, children }: { title: string; children: React.ReactNode }): JSX.Element {
  return (
    <section className="mb-8">
      <h2 className="mb-3.5 font-id text-caption uppercase tracking-[0.16em] text-text-3">
        {title}
      </h2>
      <div className="flex flex-wrap items-center gap-3.5">{children}</div>
    </section>
  )
}
